import { render, staticRenderFns } from "./VpsUpgradePlans.vue?vue&type=template&id=0cdcb1b4&"
import script from "./VpsUpgradePlans.vue?vue&type=script&lang=js&"
export * from "./VpsUpgradePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports